export function createEventDateConstants() {
  const constants = {};

  constants.base = "2022-01-01";

  constants.maxDays = 365;
  constants.maxOffers = 20;

  constants.states = [
    { value: "none", display: "ticking", offer: false, launch: false },
    { value: "initiated", display: "ticking", offer: true, launch: false },
    { value: "ticking", display: "ticking", offer: true, launch: false },
    {
      value: "launchable",
      display: "launchable",
      offer: true,
      launch: false,
    },
    { value: "triggered", display: "launched", offer: false, launch: true },
    { value: "cancelled", display: "cancelled", offer: false, launch: true },
    { value: "expired", display: "expired", offer: false, launch: true },
    { value: "updating", display: "updating", offer: false, launch: false },
  ];
  constants.preLaunchStates = [];
  constants.launchStates = [];
  for (let state of constants.states) {
    if (state.launch) {
      constants.launchStates.push(state.value);
    } else {
      constants.preLaunchStates.push(state.value);
    }
  }

  return constants;
}
